import styled from 'styled-components'

const IntroStyle = styled.div`
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 40vw;
  margin-top: 40%;
  margin-bottom: 10vh;

  button {
    background-color: rgb(0, 0, 0, 0.75);
    color: ${(props) => props.theme.text};
    padding: 0.5rem 1rem;
    background:
      linear-gradient(rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)) padding-box,
      linear-gradient(
          -205deg,
          ${(props) => props.theme.primary},
          ${(props) => props.theme.secondary}
        )
        border-box;
    border-radius: 0.25rem;
    border: 2px solid transparent;
    color: darkblue;
    padding: 0.5rem 1rem;
    color: ${(props) => props.theme.text};
    cursor: pointer;
  }

  .logo {
    width: 100px;
    height: 100px;
  }

  @media (max-width: 768px) {
    width: 80vw;
  }
`

export default IntroStyle
